import React from 'react'

import { useTheme } from '~/common/theme'
import Text from '~/views/components/ui/Text'

import { Container, StatusBadge } from './Styled'

interface StatusProps {
  value: number
  label: string
  color: string
  textColor?: string
  dotColor?: string
}

const TaskStatusLabel: React.FC<StatusProps> = ({ value, label, color }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <StatusBadge color={color}>
        <Text size="small" weight="bold">
          {label} | {value}
        </Text>
      </StatusBadge>
    </div>
  )
}

interface Props {
  notStarted?: number
  working?: number
  stuck?: number
  signOff?: number
  done?: number
  labels: {
    // "Not Started"
    notStarted: string

    // "In Progress"
    inProgress: string

    // "Stuck"
    stuck: string

    // "Sign Off"
    signOff: string

    // "Done"
    done: string
  }
}

const TaskBreakdownV2: React.FC<Props> = ({
  notStarted = 0,
  working = 0,
  stuck = 0,
  signOff = 0,
  done = 0,
  labels,
}) => {
  const theme = useTheme()

  return (
    <Container>
      <TaskStatusLabel
        value={notStarted}
        color={theme.palette.status.notStarted}
        label={labels?.notStarted}
      />
      <TaskStatusLabel
        color={theme.palette.status.workingOnIt}
        value={working}
        label={labels?.inProgress}
      />
      <TaskStatusLabel
        color={theme.palette.status.stuck}
        value={stuck}
        label={labels?.stuck}
      />
      <TaskStatusLabel
        color={theme.palette.status.signOff}
        value={signOff}
        label={labels?.signOff}
      />
      <TaskStatusLabel
        color={theme.palette.status.done}
        value={done}
        label={labels?.done}
      />
    </Container>
  )
}

export default TaskBreakdownV2
